import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=1508deca&scoped=true&"
import script from "./Dashboard.vue?vue&type=script&lang=js&"
export * from "./Dashboard.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard.vue?vue&type=style&index=0&id=1508deca&lang=scss&scoped=true&"
import style1 from "./Dashboard.vue?vue&type=style&index=1&id=1508deca&scoped=true&lang=css&"
import style2 from "./Dashboard.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1508deca",
  null
  
)

export default component.exports